/**
 * Párrafo item
 * @param {*} editor
 */
function span(editor) {
  const cm = editor.codemirror;
  const selectedText = cm.getSelection();
  const text = selectedText;

  const output = `{${text}}`;
  cm.replaceSelection(output);
}

export default function () {
  const option = {
    name: 'Agrupado',
    action: span,
    className: 'zmdi zmdi-space-bar',
    title: 'Agrupado',
  };

  return option;
}
